import {Component, EventEmitter, Input, Output, signal} from '@angular/core';

@Component({
  selector: 'app-cl-tab',
  template: '<ng-content></ng-content>',
  styleUrls: ['./cl-tab.component.scss'],
  // The host is the library's panel: a sibling of the tab strip's radios, shown by
  // `.cl-tab-N:checked ~ .cl-tab-content.cl-tab-N`.
  host: {
    'class': 'cl-tab-content',
    '[class]': "'cl-tab-' + position()",
  },
  standalone: false
})
export class ClTabComponent {

  @Input() tab_title: string;

  /**
   * Stable id for remembering this tab across reloads. Only used when the enclosing `app-cl-tabs`
   * sets `rememberAs`; the title is not usable for it, since it is display text that may be
   * reworded without anyone thinking of the stored value.
   */
  @Input() key: string | null = null;

  active = signal<boolean>(false);

  /** 1-based place in the strip, set by `app-cl-tabs`; pairs this panel with its radio and label. */
  position = signal<number>(0);

  @Output() activated = new EventEmitter<void>();

}
